<template lang="pug">
  div(:class="{'d-flex': floatRight}")
    .flex-fill(v-if="floatRight")
    nav
      ul.pagination
        .page-item.cursor-pointer(:class="{disabled: page === 1}")
          .page-link.cur(@click="setPage(page-1)") Previous
        .page-item.cursor-pointer(v-for="item in pagesSlice" :class="{active: page === item}")
          .page-link(@click="setPage(item)") {{item}}
        .page-item.cursor-pointer(:class="{disabled: page === lastPage}")
          .page-link(@click="setPage(page+1)") Next
</template>

<script>
  export default {
    name: 'pagination',
    props: {
      page: Number,
      items: Number,
      itemsPerPage: { type: Number, default: 10 },
      maxPagesView: { type: Number, default: 10 },
      floatRight: { type: Boolean, default: true },
    },
    computed: {
      lastPage() {
        return Math.ceil(this.items / this.itemsPerPage);
      },
      pages() {
        return Array.from({ length: this.lastPage }, (v, i) => i + 1);
      },
      pagesSlice() {
        const start = Math.max(this.page - this.maxPagesView / 2, 1);
        return this.pages.slice(start - 1, start + this.maxPagesView);
      },
    },
    methods: {
      setPage(page) {
        this.$emit('update:page', page);
      },
    },
  }
</script>

<style lang="stylus" scoped>

</style>
